import { render, staticRenderFns } from "./TextBlockWidget.vue?vue&type=template&id=56ce7142&scoped=true"
import script from "./TextBlockWidget.vue?vue&type=script&lang=js"
export * from "./TextBlockWidget.vue?vue&type=script&lang=js"
import style1 from "./TextBlockWidget.vue?vue&type=style&index=1&id=56ce7142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ce7142",
  null
  
)

export default component.exports